import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { NumberInput } from 'core-components/library/inputs'
import { urlValidation } from 'core-components/library/richTextEditor/helpers/urlHelper'
import { TIFrame } from 'core-components/library/richTextEditor/interface/TIFrame'
import { Controller, ValidateInput, ValidationStatus } from 'core-components/library/validation'

import styles from './IFrameSettingsDialog.module.scss'

interface IProps {
  iframeSettings: TIFrame
  onCancel: () => void
  onSave: (iframeSettings: TIFrame) => void
}

export const IFrameSettingsDialog = (props: IProps) => {
  const [canSave, setCanSave] = useState(false)
  const [editedSettings, setEditedSetting] = useState({
    ...props.iframeSettings,
  })

  return (
    <Controller
      onValidationStatusChange={(result) => {
        setCanSave(result.status === ValidationStatus.Valid)
      }}
    >
      <ValidateInput
        label={'link'}
        value={editedSettings.url || ''}
        onChange={(value) => setEditedSetting((prev) => ({ ...prev, url: value }))}
        margin={'md'}
        checkFn={urlValidation}
      />
      <NumberInput
        label={'height'}
        value={editedSettings.height || ''}
        onChange={(value) => setEditedSetting((prev) => ({ ...prev, height: value }))}
        endContent={<div>px</div>}
        margin={'md'}
      />
      <div className={styles.buttons}>
        <Button
          className={styles.button}
          disabled={!canSave}
          onClick={() => props.onSave(editedSettings)}
        >
          Save
        </Button>
        <Button className={styles.button} onClick={() => props.onCancel()}>
          Cancel
        </Button>
      </div>
    </Controller>
  )
}
